import React from 'react';
import { Container, Row, Col, Card, Table, Nav, Button, Badge } from 'react-bootstrap';
import './CabinetChildren.css';

import expand_icon_up from '../../img/arrow-up-fill.svg'
import expand_icon_down from '../../img/arrow-down-fill.svg'

const CabinetChildrenPage = () => {
  return (
    <div className="cabinet-children-page">
      <main className="main-content">
        <Container fluid>
          <Row>
            {/* Main Content */}
            <Col md={12} className="main-content-area">
              <div className="content-wrapper">
                <Card className="application-card">
                  <div className="card-header">
                    <div className="applicant-info">
                      <h3 className="applicant-name">Валерія</h3>
                      <span className="badge status-selected">В садочку</span>
                    </div>
                    <div className="application-meta">
                      <a href="#" className="regulate-btn">Редагувати</a>
                    </div>
                  </div>
                  <Card.Body>
                    <div className="birth-certificate-wrapper">
                      <div className="birth-certificate">
                        <div className="certificate-info">
                          <div className="certificate-details">
                            <span className="certificate-text">Заклад дошкільної освіти 200 </span>
                            <span className="certificate-date">Група повного дня: 03.2024 Малятко</span>
                          </div>
                          <img src={expand_icon_down} alt="expand" className="expand-icon" />
                        </div>
                      </div>
                    </div>
                    
                    <div className="registration-info">
                      <span className="registration-text">Картка киянина підтвержена</span>
                      <span className="certificate-date">22.05.2024</span>
                      <span className="dot-separator">•</span>
                      <a href="#" className="update-data-link">Оновити дані</a>
                    </div>
                    <div className="child-card-body">
                      <Nav variant="tabs">
                        <Nav.Item>
                          <Nav.Link active>Історія</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link>Нарахування</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link>Відвідування</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link>Оплати</Nav.Link>
                        </Nav.Item>
                      </Nav>
                      <div className="tab-content">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>№</th>
                              <th>Дата</th>
                              <th>Подія</th>
                              <th>Сад</th>
                              <th>Група</th>
                              <th>Тип</th>
                              <th>Район</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>13.01.2024</td>
                              <td>Оформлена до садочку</td>
                              <td>№530</td>
                              <td>03.2024 Малятко, перша молодша група — від 2-х до 3-х років</td>
                              <td>Повного дня</td>
                              <td>Святошинський</td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>29.03.2024</td>
                              <td>Оформлена до садочку</td>
                              <td>№530</td>
                              <td>03.2024 Малятко, перша молодша група — від 2-х до 3-х років</td>
                              <td>Повного дня</td>
                              <td>Святошинський</td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>11.08.2024</td>
                              <td>Оформлена до садочку</td>
                              <td>№530</td>
                              <td>03.2024 Малятко, перша молодша група — від 2-х до 3-х років</td>
                              <td>Повного дня</td>
                              <td>Святошинський</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </Card.Body>
                  <div className="child-card-footer">
                    <a href="#" className="btn btn-link">Завантажити рахунок для сплати послуг харчування</a>
                  </div>   
                </Card>

                <Card className="application-card">
                  <div className="card-header">
                    <div className="applicant-info">
                      <h3 className="applicant-name">Софія</h3>
                      <span className="badge status-selected">Дитина відрахована</span>
                    </div>
                    <div className="application-meta">
                      <a href="#" className="regulate-btn">Редагувати</a>
                    </div>
                  </div>
                  <Card.Body>
                    <div className="birth-certificate-wrapper">
                      <div className="birth-certificate">
                        <div className="certificate-info">
                          <div className="certificate-details">
                            <span className="certificate-text">Заклад дошкільної освіти 200 </span>
                            <span className="certificate-date">Група повного дня: 03.2024 Малятко</span>
                          </div>
                          <img src={expand_icon_down} alt="expand" className="expand-icon" />
                        </div>
                      </div>
                    </div>
                    
                    <div className="registration-info">
                      <span className="registration-text">Картка киянина підтвержена</span>
                      <span className="certificate-date">22.05.2024</span>
                      <span className="dot-separator">•</span>
                      <a href="#" className="update-data-link">Оновити дані</a>
                    </div>
                    <div className="child-card-body">
                      <Nav variant="tabs">
                        <Nav.Item>
                          <Nav.Link active>Історія</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link>Нарахування</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link>Відвідування</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link>Оплати</Nav.Link>
                        </Nav.Item>
                      </Nav>
                      <div className="tab-content">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>№</th>
                              <th>Дата</th>
                              <th>Подія</th>
                              <th>Сад</th>
                              <th>Група</th>
                              <th>Тип</th>
                              <th>Район</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>13.01.2024</td>
                              <td>Оформлена до садочку</td>
                              <td>№530</td>
                              <td>03.2024 Малятко, перша молодша група — від 2-х до 3-х років</td>
                              <td>Повного дня</td>
                              <td>Святошинський</td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>29.03.2024</td>
                              <td>Оформлена до садочку</td>
                              <td>№530</td>
                              <td>03.2024 Малятко, перша молодша група — від 2-х до 3-х років</td>
                              <td>Повного дня</td>
                              <td>Святошинський</td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>11.08.2024</td>
                              <td className="reject">Відрахована</td>
                              <td>№530</td>
                              <td>03.2024 Малятко, перша молодша група — від 2-х до 3-х років</td>
                              <td>Повного дня</td>
                              <td>Святошинський</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </Card.Body>
                  <div className="child-card-footer child-card-footer-actions">
                    <Button variant="primary">Запис до школи</Button>
                    <div className="application-meta">
                      <a href="#" className="regulate-btn">Нарахування</a>
                    </div>
                  </div>   
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
};

export default CabinetChildrenPage;